import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import darkModeReducer from "../globalComponents/slice/modeSlice";
import { voiceChatSlice } from "../store/communication";
import userInfoReducer from "../globalComponents/slice/userDataSlice"
import  searchFeedReducer  from "../Components/Topics/slice";
import feedsReducer from "../Components/Home/slice"
import { conversationSelector, textChatSlice } from "../store/chats";
export const store = configureStore({
  reducer: {
    counter: counterReducer,
    darkModeReducer,
    room: voiceChatSlice.reducer,
    userInfoReducer,
    searchFeedReducer,
    feedsReducer,
    textChat: textChatSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const {
  addConsumer,
  addProducers,
  removeConsumer,
  removeProducers,
  resetRoomSettings,
  updateIsRoomLoading,
  updateMicSetting,
  updateRoomStatusMessage,
  updateUserPriviledge,
  closeProducers,
  pauseProducer,
  resumeProducer,
  joiningRoom,
  roomSignInError,
  showFloatedVoiceSettings,
  addUsersToRoom,
  removeUserFromRoom,
  setRoomTokenAndId,
  setUserDropHand,
  setUserRaisedHand,
  toggleMyHand,
  mutedByAdminToggle,
  removeUserAsSpeaker,
  temporarySpeakerUpdate,
  updateUserToSpeaker,
  youHaveBeenBlocked,
  youHaveBeenKickedOut,
  setjoinRoom,
  setNewNotification,
  updateisSpeaking
} = voiceChatSlice.actions;

export const { removeTempMessage, pushNewMessage, pushTempMessage, pushChatMessage  } = textChatSlice.actions

export const chatRoomConversations = (chatroom_id:number| null | undefined) => !chatroom_id ? [] : conversationSelector.selectAll(store.getState()).filter(data => +data.chatroom_id === +chatroom_id)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;